import React from 'react'
import PropTypes from 'prop-types'

const Base = ({ children, width, height, viewBox, className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
      {...rest}
    >
      {children}
    </svg>
  )
}

Base.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  className: PropTypes.string,
}

export default Base
